import { computeWorkerMatchScore } from "../../../services/talent/MatchEngine";
import EnterpriseStatusPill from "../../../enterprise/components/EnterpriseStatusPill.jsx";
import {
  getWorkerDisplayName,
  getWorkerEmail,
  getWorkerPrimaryRole,
} from "../../../utils/workerDisplay";


export default function ApplicantRow({
  worker,
  onReviewWorker,
  onViewWorker,
  onApproveRegistration,
  onOpenProfile,
}) {

  const u = worker;
  const matchScore = computeWorkerMatchScore(u);

  return (
    <div className="ao-applicant"
      key={u.uid || u.id || u.email}
      style={{
        display: "grid",
        gridTemplateColumns: "2fr 1fr 1fr 1.4fr 1fr 1fr 1fr",
        gap: 10,
        padding: "12px 0",
        borderBottom: "1px solid #f1f5f9",
        alignItems: "center",
      }}
    >
      <div>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div
            style={{
              width: 38,
              height: 38,
              borderRadius: "50%",
              background: "#2563eb",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 900,
              fontSize: 15,
            }}
          >
            {((u.firstName?.[0] || "") + (u.lastName?.[0] || "")).toUpperCase() || "W"}
          </div>

          <div>
            <div style={{ fontWeight: 900 }}>
              {getWorkerDisplayName(u)}
            </div>

            <div style={{ fontSize: 12, color: "#64748b" }}>
              {getWorkerEmail(u)}
            </div>
          </div>
        </div>
      </div>

      <div>{getWorkerPrimaryRole(u)}</div>

      <div>
        <div style={{ fontWeight: 900 }}>{u.homeZip || "-"}</div>
        <div style={{ fontSize: 11, color: "#64748b", fontWeight: 700 }}>
          {[u.city, u.state].filter(Boolean).join(", ") || "No city/state"}
        </div>
      </div>

      <div>
        <div style={{ fontWeight: 900 }}>{u.yearsExperience || 0} yrs</div>

        <div style={{ fontSize: 11, color: "#64748b", fontWeight: 700 }}>
          Radius: {u.travelRadiusMiles || 0} mi
        </div>

        <div
          style={{
            marginTop: 4,
            display: "inline-block",
            padding: "2px 8px",
            borderRadius: 999,
            background: u.hasTransportation ? "#dcfce7" : "#fee2e2",
            color: u.hasTransportation ? "#166534" : "#991b1b",
            fontSize: 10,
            fontWeight: 900,
          }}
        >
          {u.hasTransportation ? "🚗 Transportation" : "⚠ No Transportation"}
        </div>

        <div style={{ marginTop: 4, fontSize: 11, color: "#334155", fontWeight: 800 }}>
          {[
            u.availableDays ? "Days" : null,
            u.availableEvenings ? "Evenings" : null,
            u.availableNights ? "Nights" : null,
            u.availableWeekends ? "Weekends" : null,
          ]
            .filter(Boolean)
            .join(" • ") || "No availability"}
        </div>

        <div style={{ marginTop: 2, fontSize: 10, color: "#64748b", fontWeight: 700 }}>
          {(u.preferredDays || []).length
            ? `Prefers: ${(u.preferredDays || []).join(", ")}`
            : "No preferred days"}
        </div>
      </div>

      <div>
        <div
          style={{
            fontWeight: 900,
            fontSize: 18,
            color:
              matchScore >= 90
                ? "#15803d"
                : matchScore >= 75
                ? "#2563eb"
                : "#d97706",
          }}
        >
          {matchScore}
        </div>
        <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b" }}>
          Match Score
        </div>
      </div>

<div>
  <EnterpriseStatusPill
    label={
      u.pipelineStage === "approved"
        ? "READY FOR SHIFTS"
        : u.pipelineStage?.replaceAll("_", " ")?.toUpperCase()
    }
    tone={
      u.pipelineStage === "invited"
        ? "info"
        : u.pipelineStage === "registered"
        ? "warning"
        : u.pipelineStage === "onboarding"
        ? "purple"
        : u.pipelineStage === "review_queue"
        ? "danger"
        : "success"
    }
  />
</div>
      <div style={{ display: "grid", gap: 6 }}>
        <button
          type="button"
          onClick={() => onOpenProfile?.(u)}
        >
          Applicant 360
        </button>

        {u.pipelineStage === "review_queue" ? (
          <button
            type="button"
            onClick={() => onReviewWorker?.(u)}
          >
            Review Docs
          </button>
        ) : u.pipelineStage === "registered" ? (
          <button
            type="button"
            onClick={() => onApproveRegistration?.(u)}
          >
            Approve Registration
          </button>
        ) : u.pipelineStage === "approved" ? (
          <button
            type="button"
            onClick={() => onViewWorker?.(u)}
          >
            View Worker
          </button>
        ) : (
          <button
            type="button"
            onClick={() =>
              alert("Invite pending. Worker has not completed signup yet.")
            }
          >
            Send Reminder
          </button>
        )}
      </div>
    </div>
  );
}